$(function() {

    // Initailise vue cart script

    var app = Vue.createApp({
        delimiters: ['${','}'],
		name: 'Product',
        data() {
            return {
                mounted: false,
                cart: window.cart,
                freeShipping: window.cartFreeShipping || false,
                over18: false,

                // Used for price formatting with moneyV2 api
                currencyCode: window.cart.currency,
                options: window.product.options,
                product: window.product,
                selectedVariantID: window.product._selectedVariantID,
                selectedOptions: window.product._selectedOptions,
                variantAvailable: true,
                qty: 1,
                maxQty: window.product.tags.find((tag) => { return tag.includes('max:') })?.replace('max:', '') || window.product._maxQty,
                events: {
                    added: new Event('itemAdded')
                }
            }
        },
        created: function() {
            this.setupCartEventHandler();
			
        },
		mounted: function() {
			this.mounted = true;
			this.lazyLoadImages();
			this.initialiseImageSliders();
		},
		beforeDestory: function() {
			
		
		},
		beforeUpdate: function() {

			//	We need to remove each slick child and unslick before vue updates otherwise
			//	we end up with duplicate slides where items have been cloned previously

			if ($('.j-main-image-carousel.slick-initialized').length) {
								
				$('.j-main-image-carousel slick-slide').remove();
				$('.j-main-image-carousel.slick-initialized').slick('unslick');

			}

			if ($('.j-image-carousel-nav.slick-initialized').length) {
								
				$('.j-image-carousel-nav slick-slide').remove();
				$('.j-image-carousel-nav.slick-initialized').slick('unslick');

			}

		},
		updated: function() {
			
			// Load review stars
			console.log("window.StampedFn",window.StampedFn)
			if(window.StampedFn){
				console.log("LOADING REVIEWS")
				window.StampedFn.loadBadges();
			}
			this.$nextTick(async function() {
				// Re-initialise slick once all previous DOM updates have been applied
				this.initialiseImageSliders();
			});

		},
        computed: {
			availableOptions: function() {
				const otherVariants = this.variants.filter(variant => variant.id !== this.selectedVariantID);
				
				const numOptions = this.options.length;
				
			
				let availableOptions = [...this.selectedOptions.map(option => [option])];
			

				if (numOptions < 2) {
					for (let variant of otherVariants) {
						availableOptions[0].push(variant.options[0]);
					}
				} else {

					otherVariants.forEach(variant => {
						for (let i = 0; i < this.options.length; i++) {
							
							if (variant.options[i] == this.selectedOptions[i]) {
								let nextIndex = 1;
	
								if (i + 1 < numOptions) {
									nextIndex = i + 1;
								} else {
									nextIndex = 0;
								}
	
								availableOptions[nextIndex].push(variant.options[nextIndex]);
							}
						}
	
					});
				}

				return availableOptions;
			},

			variants: function () {
				return this.product.variants.map(variant => {
					const images = [];

					for (image of this.product._images) {
						if (image.variants.length) {
							for (associatedVariant of image.variants) {
								if (associatedVariant.id === variant.id) {
									images.push(image.src);
								}
							}
						} else {
							if (image.alt.includes(' - ')) {
								if (image.alt.split(' - ')[1] === variant.public_title) {
									images.push(image.src);
								}
							}

						}
					}

					return {
						...variant,
						images,
						compare_at_price: variant.compare_at_price ? new Intl.NumberFormat('en-GB', { style: 'currency', currency: this.currencyCode }).format(variant.compare_at_price / 100) : null,
						price: new Intl.NumberFormat('en-GB', { style: 'currency', currency: this.currencyCode }).format(variant.price / 100)
					 }
				});
			},

			/** This filters out any images that aren't assigned to a variant and can be used for all products **/
			sharedImages: function () {
				
				const sharedImages =  this.product._images.filter(image => {
					let variantImage = false;				
					
					if (image.alt.includes(' - ')) {
						
						this.product.variants.forEach(variant => {
							
							if (image.alt.split(' - ')[1] === variant.public_title) {
								variantImage = true;
							} else if(image.alt.split(' - ')[1].split(' / ').reverse().join(' / ') === variant.public_title) {
								variantImage = true;
							}
						});

					}

					return variantImage ? false : true;
				}).map(image => image.src);

				

				return sharedImages;
			},


			/** This combines the variant specific images with the shared images to show in the carousel **/
			combinedImages: function () {
				const selectedVariant = this.variants.filter(variant => variant.id === this.selectedVariantID);
				
				return [...selectedVariant[0].images, ...this.sharedImages];
			},

			selectedVariant: function () {
				return this.variants.filter(variant => variant.id === this.selectedVariantID)[0];
			}
           
        },

        methods: {
			lazyLoadImages: function () {
				if ("loading" in HTMLImageElement.prototype) {
					var images = document.querySelectorAll('img[loading="lazy"][data-src]');

					images.forEach(function (image) {
						image.src = image.dataset.src;
						if (image.dataset.srcset) {
							image.srcset = image.dataset.srcset;
						}
					});
				}
			},

			initialiseImageSliders: function () {
				this.lazyLoadImages();
									
				$('.j-main-image-carousel').slick({
					infinite: false,
					arrows: true,
					dots: false,
					autoplay: false,
					// slidesToShow: 1,
					// slidesToScroll: 1,
					variableWidth: true,
					swipeToSlide: true,
					asNavFor: '.j-image-carousel-nav'
				});

				$('.j-image-carousel-nav').slick({
					infinite: false,
					arrows: false,
					dots: true,
					variableWidth: true,
					swipeToSlide: true,
					draggable: false,
					asNavFor: '.j-main-image-carousel',
					focusOnSelect: true
				});
			},

			// Select an option
			selectOption: function ({ position, value }) {
				const newOptions = [...this.selectedOptions];
				newOptions[position - 1] = value;

				this.selectedOptions = newOptions;

				let newVariant = this.variants.filter(variant => {

					if (this.options.length < 2) {
						if (variant.options[0] !== newOptions[0]) return false;
					} else {
						for (let i = 0; i < newOptions.length; i++) {
							if (variant.options[i] !== newOptions[i]) return false;
						}
					}

					return true;
				})[0];
			

				if(newVariant == undefined) {
					newVariant = this.variants.filter(variant => {
						if (variant.options[position - 1] != value) return false;
						return true;
					})[0];

					this.selectedOptions = [...newVariant.options]
				}

				this.selectedVariantID = newVariant.id;
				//this.maxQty = newVariant.inventory_quantity;
				this.qty = 1;

				// append the variant query to the url
				const url = new URL(window.location);
				url.searchParams.set('variant', newVariant.id);
				window.history.pushState({}, '', url);
				
			},

			// For adding a class (temp or permanent) during an event
			addClass: function(e, className, { forward = true, duration = 500, elem = undefined }) {
				
				if (elem) {
					$(elem).addClass(className);
				} else {
					$(e.target).addClass(className);
				}
				
				if (!forward) {
					setTimeout(function () {
						if (elem) {
							$(elem).removeClass(className);
						} else {
							$(e.target).removeClass(className);
						}
					}, duration);
				}
			},

			// Update the cart with the new quantity
			updateQty: function(e) {
				if (Number.isNaN(parseInt(e.target.value, 10)) || (parseInt(e.target.value, 10) > this.maxQty)) return;
				
				this.qty = parseInt(e.target.value, 10);
								
				if (window.navigator.vibrate) { 
					window.navigator.vibrate(100);
				}
			},

            setupCartEventHandler: function () {
                var $this = this;
                $(document).on('cart.requestComplete cart.afterManualUpdate', function(event, cart) {
					
					$this.cart = cart;

                    $('.j-toggle-cart span').text(cart.item_count);
					$('.cart-icon span').text(cart.item_count);

                });
            },

			addToCart: function ({ vid, qty = 1, properties= {} }, callback) {
				const vm = this;

				if (!vid) {
					// Require a Variant ID
					throw Error('A variant ID (vid) must be provided');
				} else {
					CartJS.addItem(vid, qty, properties, {
						success: function (data, textStatus, jqXHR) {
							console.log('Item Added To Cart');

							if (callback) {
								callback(null, data);
							}

							document.dispatchEvent(vm.events.added);
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.error('Cart.js Error');
			
							if (callback) {
								callback(jqXHR);
							} else {
								console.log(jqXHR);
								console.error(errorThrown);
							}
						}
					});
				}
			},

            increment: function(){
				if (parseInt(this.qty, 10) == this.maxQty) return;
                this.qty = parseInt(this.qty + 1, 10);

				if (window.navigator.vibrate) { 
					window.navigator.vibrate(100);
				}
            },

            decrement: function(){
				if (parseInt(this.qty, 10) === 0) return;

				this.qty = parseInt(this.qty - 1, 10);
                
				if (window.navigator.vibrate) { 
					window.navigator.vibrate(100);
				}
            },

            isSubscription: function(line_item){
                if (line_item != null && line_item.properties != null && typeof line_item.properties.frequency_num != 'undefined') {
                    return true;
                } else {
                    return false;
                }
            },

			generateSrcSet: function(url) {
				if (!url) return;

				const widths = [180,360,540,720,900,1080,1296,1512,1728,1944,2160,2376,2592,2808,3024];

				const fileTypes = new RegExp(/\.(gif|jpe?g|tiff?|png|webp|avif|bmp)/, 'i');

				return widths.reduce((srcset, width, index) => {
					const fileType = url.match(fileTypes)[0];

					return `${srcset} ${url.replace(fileType, `_${width}x${fileType}`)} ${width}w${index < widths.length ? "," : ""}`;
				}, '');
			},

			isJPEG: function(url) {
				if (!url) return false;
				
				const fileTypes = new RegExp(/\.(gif|jpe?g|tiff?|png|webp|avif|bmp)/, 'i');
				const fileType = url.match(fileTypes)[0];

				return (fileType === '.jpg' || fileType === '.jpeg') ? true : false;
			}
			
        }
    }).mount('#vue-product-details')

});